<script setup lang="ts">

import { useResellerPresentation } from './ResellerPresentation';
import Presentation from '@presentation/Templates/Presentation.vue';

useResellerPresentation(); 

</script>

<template>
    <Presentation />
</template>